// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-info-display {
  position: fixed;
  top: 0;
  right: 3.5rem;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 8px 12px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
}
.user-info-name {
  font-size: 1rem;
}
.user-info-org {
  font-size: 1.2rem;
  color: #6B7280;
}

.user-info-role {
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/composants/UserInfo/UserInfo.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,aAAa;EACb,0CAA0C;EAC1C,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".user-info-display {\n  position: fixed;\n  top: 0;\n  right: 3.5rem;\n  background-color: rgba(255, 255, 255, 0.9);\n  padding: 8px 12px;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  display: flex;\n  align-items: flex-end;\n}\n.user-info-name {\n  font-size: 1rem;\n}\n.user-info-org {\n  font-size: 1.2rem;\n  color: #6B7280;\n}\n\n.user-info-role {\n  font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
